import globals from "../Globals.json";
import api from "./api";

export const showSale = (uuid: string) => {
  return api.get(`${globals.api.sales}/${uuid}`);
};
